import { getClosestConfigurationFromGeneralAdmission } from '%paysera_seat_selection/js/seatSelection/redux/component/orm/services/getClosestConfiguration';
import {
    LABEL_ICON_DISABLED,
    LABEL_ICON_FOR_CASHIER,
    LABEL_ICON_RESERVED,
} from '%paysera_seat_selection/js/seatSelection/config/constants';

function compileGeneralAdmissionLabel(generalAdmission) {
    const { fontConfig } = getClosestConfigurationFromGeneralAdmission(generalAdmission, 'fontConfig');
    const {
        compiled: { polygon: { dimensions: { width, height } } },
        transformation: { rotation },
        label: { manual, text },
    } = generalAdmission;

    if (text === null) {
        return generalAdmission;
    }

    const label = {
        ...generalAdmission.label,
        compiled: {
            ...generalAdmission.label.compiled,
            family: fontConfig.family,
            color: fontConfig.color,
            size: fontConfig.size.generalAdmission,
        },
        transformation: {
            rotation: -rotation,
        },
    };

    label.icon = null;
    if (generalAdmission.forCashier) {
        label.icon = LABEL_ICON_FOR_CASHIER;
    }
    if (!generalAdmission.enabled) {
        label.icon = LABEL_ICON_DISABLED;
    }
    if (generalAdmission.reservation !== null) {
        label.icon = LABEL_ICON_RESERVED;
    }

    if (manual) {
        generalAdmission.label = label;

        return generalAdmission;
    }

    label.compiled = {
        ...label.compiled,
        x: width / 2,
        y: height / 3,
    };

    const { compiled } = label;
    label.compiled.text = { ...compiled.text, x: compiled.x, y: compiled.y };

    generalAdmission.label = label;

    return generalAdmission;
}

export default compileGeneralAdmissionLabel;
